module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h-card', {
    attrs: {
      "fields": _vm.fields,
      "link": ("/course/" + (_vm.courseInstance.id))
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b6ede0d"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseCard.vue
// module id = 535
// module chunks = 1